import { render, staticRenderFns } from "./graduationIndex.vue?vue&type=template&id=2bdd4a89&"
import script from "./graduationIndex.vue?vue&type=script&lang=js&"
export * from "./graduationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports